import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILED,
  GET_ORDER_WITH_ID,
  GET_ORDER_WITH_ID_SUCCESS,
  GET_ORDER_WITH_ID_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  SCHEDULE_ORDERS,
  SCHEDULE_ORDERS_SUCCESS,
  SCHEDULE_ORDERS_FAILED,
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_ALL_ORDERS_REPORT,
  GET_ALL_ORDERS_REPORT_SUCCESS,
  GET_ALL_ORDERS_REPORT_FAILED,
  ASSIGN_ORDER,
  ASSIGN_ORDER_FAILED,
  ASSIGN_ORDER_SUCCESS,
  GET_POST_ORDERS,
  GET_POST_ORDERS_SUCCESS,
  GET_POST_ORDERS_FAILED,
  CREATE_POST_ORDERS_SUCCESS,
  CREATE_POST_ORDERS_FAILED,
  CREATE_POST_ORDERS,
  GET_ORDERS_PRINT,
  GET_ORDERS_PRINT_SUCCESS,
  GET_ORDERS_PRINT_FAILED,
  CHANGE_DELIVERY_TYPE,
  CHANGE_DELIVERY_TYPE_SUCCESS,
  CHANGE_DELIVERY_TYPE_FAILED,
  GET_ORDER_ITEMS,
  GET_ORDER_ITEMS_SUCCESS,
  GET_ORDER_ITEMS_FAILED,
  CLEAR_ORDER,
  CREATE_ORDER_ITEMS,
  CREATE_ORDER_ITEMS_SUCCESS,
  CREATE_ORDER_ITEMS_FAILED,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILED,
  GET_PROVINCES,
  GET_PROVINCES_SUCCESS,
  GET_PROVINCES_FAILED,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
  GET_ALL_POST_ORDERS,
  GET_ALL_POST_ORDERS_SUCCESS,
  GET_ALL_POST_ORDERS_FAILED,
  GET_POST_ORDER_WITH_ID,
  GET_POST_ORDER_WITH_ID_SUCCESS,
  GET_POST_ORDER_WITH_ID_FAILED,
} from './constants';

export const initialState: State = {
  ordersList: [],
  provinces: [],
  cities: [],
  ordersPrintList: [],
  allOrdersReport: [],
  postOrder: {},
  currentPostOrder: {},
  postOrders: [],
  orderItems: [],
  allPostOrders: [],
  order: {},
  logs: [],
  bundleAssignment: [],
  count: 0,
  postOrdersCount: 0,
  provincesCount: 0,
  citiesCount: 0,
  loading: false,
  provinceLoading: false,
  cityLoading: false,
  error: '',
  citiesError: '',
  provincesError: '',
  deliveredCount: 0,
  deliveringCount: 0,
  deliverdPostCount: 0,
  processingCount: 0,
};

export const OrdersReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_ORDERS:
        draft.loading = true;
        break;
      case GET_ORDERS_SUCCESS:
        draft.ordersList = action.data;
        draft.allOrdersReport = [];
        draft.count = action.count;
        draft.deliveredCount = action.deliveredCount;
        draft.processingCount = action.processingCount;
        draft.deliveringCount = action.deliveringCount;
        draft.deliverdPostCount = action.deliverdPostCount;
        draft.loading = false;
        break;
      case GET_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_ORDER_WITH_ID:
        draft.loading = true;
        break;
      case GET_ORDER_WITH_ID_SUCCESS:
        draft.order = action.data;
        draft.loading = false;
        break;
      case GET_ORDER_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_POST_ORDER_WITH_ID:
        draft.loading = true;
        break;
      case GET_POST_ORDER_WITH_ID_SUCCESS:
        draft.currentPostOrder = action.data;
        draft.loading = false;
        break;
      case GET_POST_ORDER_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PROVINCES:
        draft.provinceLoading = true;
        break;
      case GET_PROVINCES_SUCCESS:
        draft.provinces = action.data;
        draft.provincesCount = action.count;
        draft.provinceLoading = false;
        break;
      case GET_PROVINCES_FAILED:
        draft.provincesError = action.error;
        draft.provinceLoading = false;
        break;

      case GET_CITIES:
        draft.cityLoading = true;
        break;
      case GET_CITIES_SUCCESS:
        draft.cities = action.data;
        draft.citiesCount = action.count;
        draft.cityLoading = false;
        break;
      case GET_CITIES_FAILED:
        draft.citiesError = action.error;
        draft.cityLoading = false;
        break;

      case ACTION_RETRIEVE_RUBIKA_ORDERS:
        draft.loading = true;
        break;
      case ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS:
        draft.loading = false;
        break;
      case ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case SCHEDULE_ORDERS:
        draft.loading = true;
        break;
      case SCHEDULE_ORDERS_SUCCESS:
        draft.bundleAssignment = action.data;
        draft.loading = false;
        break;
      case SCHEDULE_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CREATE_POST_ORDERS:
        draft.loading = true;
        break;
      case CREATE_POST_ORDERS_SUCCESS:
        draft.postOrder = action.data;
        draft.loading = false;
        break;
      case CREATE_POST_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_POST_ORDERS:
        draft.loading = true;
        break;
      case GET_ALL_POST_ORDERS_SUCCESS:
        draft.allPostOrders = action.data;
        draft.postOrdersCount = action.count;
        draft.loading = false;
        break;
      case GET_ALL_POST_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_POST_ORDERS:
        draft.loading = true;
        break;
      case GET_POST_ORDERS_SUCCESS:
        draft.postOrders = action.data;
        draft.loading = false;
        break;
      case GET_POST_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_LOGS:
        draft.loading = true;
        break;
      case GET_LOGS_SUCCESS:
        draft.logs = action.data;
        draft.loading = false;
        break;
      case GET_LOGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_ORDERS_REPORT:
        draft.loading = true;
        break;
      case GET_ALL_ORDERS_REPORT_SUCCESS:
        draft.allOrdersReport = action.data;
        draft.loading = false;
        break;
      case GET_ALL_ORDERS_REPORT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ORDERS_PRINT:
        draft.loading = true;
        break;
      case GET_ORDERS_PRINT_SUCCESS:
        draft.ordersPrintList = action.data;
        draft.loading = false;
        break;
      case GET_ORDERS_PRINT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case ASSIGN_ORDER:
        draft.loading = true;
        break;
      case ASSIGN_ORDER_FAILED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case ASSIGN_ORDER_SUCCESS:
        draft.loading = false;
        break;

      case CHANGE_DELIVERY_TYPE:
        draft.loading = true;
        break;
      case CHANGE_DELIVERY_TYPE_FAILED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case CHANGE_DELIVERY_TYPE_SUCCESS:
        draft.loading = false;
        break;

      case GET_ORDER_ITEMS:
        draft.loading = false;
        break;
      case GET_ORDER_ITEMS_SUCCESS:
        draft.orderItems = action.data;
        draft.loading = false;
        break;
      case GET_ORDER_ITEMS_FAILED:
        draft.loading = false;
        draft.error = action.error;
        break;

      case CLEAR_ORDER:
        draft.order = {};
        draft.orderItems = [];
        break;

      case CREATE_ORDER_ITEMS:
        draft.loading = true;
        break;
      case CREATE_ORDER_ITEMS_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_ORDER_ITEMS_FAILED:
        draft.loading = false;
        break;

      case UPDATE_ORDER:
        draft.loading = true;
        break;
      case UPDATE_ORDER_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_ORDER_FAILED:
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default OrdersReducer;
